import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "How much does asphalt coring cost in Houston?",
    a: "Coring and boring prices are quoted per project based on scope, depth, soil conditions, site access, and location. Send us your project details through the quote form and we'll respond with exact pricing, typically within one business day.",
  },
  {
    q: "What areas do you serve?",
    a: "We provide coring and boring services throughout Greater Houston and surrounding communities, including Harris, Fort Bend, Montgomery, Brazoria, and Galveston counties.",
  },
  {
    q: "How fast can you mobilize a crew?",
    a: "Fast mobilization is one of the things clients choose us for. We offer flexible scheduling, including nights and weekends, built around your project timeline. Tell us your preferred date and we'll work to meet it.",
  },
  {
    q: "What's the difference between concrete coring and geotechnical boring?",
    a: "Concrete and asphalt coring uses diamond core bits to extract clean cylindrical samples from pavements and structures for testing. Geotechnical boring drills into the soil below to collect samples and data for foundation design and environmental assessment.",
  },
  {
    q: "Do you provide boring logs and documentation?",
    a: "Yes. Every project includes professional documentation: boring logs, core records, and photos delivered in an engineer-ready format.",
  },
  {
    q: "Who do you typically work with?",
    a: "Engineering firms, testing laboratories, general contractors, developers, roadway contractors, commercial construction companies, and government agencies across the Houston area.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 lg:py-32 bg-white" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A00] mb-4 font-mono-tech" data-testid="faq-overline">
            FAQ • 06
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-[#0F172A]" data-testid="faq-heading">
            Common Questions
          </h2>
          <p className="mt-6 text-base text-slate-600 leading-relaxed">
            Answers about asphalt coring, concrete coring, and geotechnical boring in Houston.
          </p>
        </div>

        <div className="mt-14 max-w-4xl border-t border-slate-200" data-testid="faq-list">
          {faqs.map((f, i) => (
            <div key={f.q} className="border-b border-slate-200">
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                data-testid={`faq-question-${i}`}
                aria-expanded={open === i}
              >
                <span className="font-heading text-base sm:text-lg font-bold text-[#0F172A] group-hover:text-[#FF5A00] transition-colors duration-200">
                  <span className="text-[#FF5A00] font-mono-tech text-sm mr-4">{String(i + 1).padStart(2, "0")}</span>
                  {f.q}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-[#FF5A00] shrink-0 transition-transform duration-300 ${open === i ? "rotate-180" : ""}`}
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 pl-0 sm:pl-12 text-base text-slate-600 leading-relaxed" data-testid={`faq-answer-${i}`}>
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
